import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import { ModelIndexHandle } from "@components/layout/ModelIndex";
import { CreditnoteApi } from "@/api/CreditnoteApi";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import CreditnoteModelIndex from "@components/dynamic/modelIndexes/CreditnoteModelIndex";

const CreditnoteListByInvoiceId = () => {
  const params = useParams()
  const { invoiceId } = params;
  const modelRef = useRef<ModelIndexHandle>(null);
  const [invoiceData, setInvoiceData] = useState<InvoiceDataType>({});

  useEffect(() => {
    loadInvoice()
  }, [invoiceId]);

  const loadInvoice = async () => {
    if (invoiceId) {
      const invoice = await InvoiceApi.get(invoiceId);
      setInvoiceData(invoice)
    } else {
      alert("No fue posible cargar la informacion de la factura")
    }
  }

  return (
    <PageContainer
      title={`Lista de Notas de Credito de Factura #${invoiceData.numero || ""}`}
      backUrl="/user/dashboard-accounting"
    >
      <CreditnoteModelIndex
        ref={modelRef}
        messages={{
          noResults: `No hay notas de credito para la Factura #${invoiceData.numero}`
        }}
        mandatoryFilters={[{ invoiceId: { eq: invoiceId } }]}
        fetchData={(...args) => CreditnoteApi.fetchAll(...args)}
      />
    </PageContainer >
  );
}

export default CreditnoteListByInvoiceId;
